import { ShareDataService } from './../share-data/share-data.service';
import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { StorageService } from '../storage/storage.service';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
  static EVENT = {
    LOGIN_REQUIRED: 'LOGIN_REQUIRED',
    LOGIN_ERROR: 'LOGIN_ERROR',
    LOGIN_TOKEN_EXPIRE: 'LOGIN_TOKEN_EXPIRE',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  }
  constructor(
    public auth: AuthService,
    public router: Router,
    public storage: StorageService,
    private shareDataService: ShareDataService
  ) {
  }
  async canActivate() {
    let token = await this.auth.isAuthenticated();
    if (!token) {
      this.openModal(AuthGuardService.EVENT.LOGIN_REQUIRED)
      return false;
    }
    return true;
  }

  openModal(event) {

    let data = {}
    if (event == AuthGuardService.EVENT.LOGIN_ERROR) {
      data = {
        status: status,
        success: false
      }
    }

    let msg = JSON.stringify({
      event: event,
      data
    })
    this.shareDataService.changeMessage(msg)
  }

}
